import styles from './ic-exclamation.module.scss';

/* eslint-disable-next-line */
export interface IcExclamationProps {
  size: number;
  color: string;
}

export function IcExclamation(props: IcExclamationProps) {
  return (
    <svg className={styles['container']} width={props.size} height={props.size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" stroke={props.color}></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke={props.color}></g>
      <g id="SVGRepo_iconCarrier" stroke={props.color}>
        <path className="cls-1" d="M6.37119,11.87271h3.2554V14H6.37119ZM6.31551,2l.37063,8.54245H9.31386L9.68449,2Z" stroke={props.color} fill={props.color}></path>
      </g>
    </svg>
  );
}

IcExclamation.defaultProps = {
  size: 24,
  color: 'white'
}

export default IcExclamation;
